import { Directive, ElementRef, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';

@Directive({
  selector: '[appOverflowListener]',
})
export class OverflowListenerDirective implements OnInit, OnDestroy {
  @Output() overflowChange = new EventEmitter<{ isOverflowingHorizontally: boolean; isOverflowingVertically: boolean }>();
  private resizeObserver: ResizeObserver;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.checkOverflow();

    this.resizeObserver = new ResizeObserver(() => this.checkOverflow());
    this.resizeObserver.observe(this.el.nativeElement);
  }

  public recalculate(): void {
    this.checkOverflow();
  }

  ngOnDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  private checkOverflow() {
    const element = this.el.nativeElement;
    const isOverflowingHorizontally = element.scrollWidth > element.clientWidth;
    const isOverflowingVertically = element.scrollHeight > element.clientHeight;

    this.overflowChange.emit({ isOverflowingHorizontally, isOverflowingVertically });
  }
}
